<template>
    <li @click="select" :key="option.handle" :class="{'active': isActive, 'submenu': option.fields}">
        <template v-if="option.layerId">
            <simple-svg
                    class="simple-svg-wrapper"
                    :filepath="getLayer(option.layerId).iconUrl"
                    :fill="getLayer(option.layerId).color"
                    :stroke="getLayer(option.layerId).stroke"
            ></simple-svg>
            <div class="layer-title">{{ getLayer(option.layerId).title }}</div>
        </template>
        <div class="layer-title">{{ option.label }}</div>
        <ul v-if="option.fields">
            <li class="btn-back" @click="select($event, true)">
                <template v-if="option.layerId">
                    <simple-svg
                            class="simple-svg-wrapper"
                            :filepath="getLayer(option.layerId).iconUrl"
                            :fill="getLayer(option.layerId).color"
                            :stroke="getLayer(option.layerId).stroke"
                    ></simple-svg>
                    <div class="layer-title">{{ getLayer(option.layerId).title }}</div>
                </template>
                {{ option.label }}
            </li>
            <filter-item-menu-item v-for="field in option.fields"
                                   :option="field"
                                   :key="field.handle"
                                   :level="level + 1"
                                   :path="path + ';' + field.handle"
                                   v-model="getValue"
                                   @change-level="changeLevel"></filter-item-menu-item>
        </ul>
    </li>
</template>

<script>
  export default {
    name: 'FilterItemMenuItem',
    props: {
      option: {
        type: Object,
        required: true
      },
      path: {
        type: [String, Number]
      },
      value: {
        type: Object
      },
      level: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        isActive: false
      }
    },
    mounted () {
      if (this.value && this.path === this.value.path) {
        this.isActive = true
        this.$emit('change-level', this.level)
      }
    },
    methods: {
      select (event, goBack) {
        if (event.handled) {
          return
        }

        if (typeof this.option.fields !== 'undefined') {
          if (typeof goBack !== 'undefined') {
            this.isActive = false
            this.$emit('change-level', this.level)
          } else {
            this.isActive = true
            this.$emit('change-level', this.level + 1)
          }
          event.handled = true
          event.stopPropagation()
        } else {
          event.handled = true
          this.$emit('input', {
            path: this.path,
            item: this.option
          })
        }
      },
      changeLevel ($event) {
        this.isActive = true
        this.$emit('change-level', $event)
      }
    },
    computed: {
      getLayer () {
        return (layerId) => this.$store.getters['layer/get'](layerId)
      },
      getValue: {
        get () {
          return this.value
        },
        set (newVal) {
          this.$emit('input', newVal)
        }
      }
    }
  }
</script>

<style scoped>

</style>
